import React, { useEffect, useState } from 'react';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const MainMenu = () => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const navigate = useNavigate();
  
    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            await Auth.currentAuthenticatedUser();
            setIsLoggedIn(true);
            
         } catch {
            console.log('in maimmenu: User not signed in');
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
  
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');    
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);

    return(

        <div className="flex-container-1">                  
            <div className="upload-container">

            <a className="loginout-button-style" href={link}>{linkText}</a> 
           
                    <div className="menu-title-container">

        


                        <div className="menu-title-text">CRSP Admin</div>
                    </div>

                    <div className="menu-buttons-container">

                        <div className="menu-items">
                                <a href="/" className="menu-button-style">Onboarding Form</a>
                        </div>
                    

                        <div className="menu-items">
                                <a href="/csv" className="menu-button-style">CSV Upload and Update</a>
                        </div>
 
                        <div className="menu-items">
                                <a href="/query" className="menu-button-style">Export to CSV</a>
                        </div>


                        <div className="menu-items">
                                <a href="/find" className="menu-button-style">Find CRSP Submission</a>
                        </div>

                        <div className="menu-items">
                                <a href="/offboard" className="menu-button-style">Offboard</a>
                        </div>

                        <div className="menu-items">
                                <a href="/offboardbulk" className="menu-button-style">Bulk Offboard</a>
                        </div>

                        <div className="menu-items">
                                <a href="/getstats" className="menu-button-style">Stats</a>
                        </div>

                        <div className="menu-items">
                                <a href="/changepassword" className="menu-button-style">Change Password</a>
                        </div>
                    </div>
                </div>
            
        </div>
    )
};
export default MainMenu;
